import { useState, useMemo } from "react";
import { PRODUCTS } from "../../mocks/products";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import CartDrawer from "../../components/feature/CartDrawer";
import FilterBar from "./components/FilterBar";
import ProductCard from "./components/ProductCard";

const TALL_INDICES = new Set([0, 3, 4, 7]);

export default function ShopPage() {
  const [category, setCategory] = useState("all");
  const [sort, setSort] = useState("default");
  const [search, setSearch] = useState("");

  const filtered = useMemo(() => {
    let list = [...PRODUCTS];

    if (search.trim()) {
      const q = search.toLowerCase();
      list = list.filter(
        (p) =>
          p.name.toLowerCase().includes(q) ||
          p.brand.toLowerCase().includes(q) ||
          p.description.toLowerCase().includes(q)
      );
    }

    if (category !== "all") {
      list = list.filter((p) => p.category === category);
    }

    if (sort === "price-asc") {
      list.sort((a, b) => a.price - b.price);
    } else if (sort === "price-desc") {
      list.sort((a, b) => b.price - a.price);
    } else if (sort === "rating") {
      list.sort((a, b) => b.rating - a.rating);
    }

    return list;
  }, [category, sort, search]);

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Navbar />
      <CartDrawer />

      {/* Page header */}
      <div className="pt-16 bg-[#1B4332]">
        <div className="max-w-7xl mx-auto px-6 py-16">
          <p className="text-white/40 text-xs tracking-widest uppercase mb-3">Our Collection</p>
          <h1 className="text-5xl md:text-6xl font-extralight text-white tracking-tight mb-4">
            商品館
          </h1>
          <p className="text-white/50 text-base">
            精選 {PRODUCTS.length} 件頂尖 3C 家電，品質保證，全台免運
          </p>
        </div>
      </div>

      <FilterBar
        category={category}
        sort={sort}
        search={search}
        onCategoryChange={setCategory}
        onSortChange={setSort}
        onSearchChange={setSearch}
      />

      {/* Product grid */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        {filtered.length === 0 ? (
          <div className="text-center py-32">
            <i className="ri-search-line text-5xl text-zinc-300 block mb-4"></i>
            <p className="text-zinc-400 text-lg mb-2">找不到符合條件的商品</p>
            <button
              onClick={() => { setCategory("all"); setSearch(""); }}
              className="mt-4 px-6 py-2.5 bg-[#1B4332] text-white text-sm rounded-sm hover:bg-zinc-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              清除篩選
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
            {filtered.map((product, i) => (
              <ProductCard
                key={product.id}
                product={product}
                tall={TALL_INDICES.has(i)}
              />
            ))}
          </div>
        )}

        {/* Results count */}
        {filtered.length > 0 && (
          <p className="text-center text-zinc-400 text-sm mt-12">
            共 {filtered.length} 件商品
          </p>
        )}
      </div>

      <Footer />
    </div>
  );
}
